import { render, staticRenderFns } from "./GestionAlertes.vue?vue&type=template&id=190a6081&scoped=true"
import script from "./GestionAlertes.vue?vue&type=script&lang=js"
export * from "./GestionAlertes.vue?vue&type=script&lang=js"
import style0 from "./GestionAlertes.vue?vue&type=style&index=0&id=190a6081&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190a6081",
  null
  
)

export default component.exports